/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import React from 'react';
import compose from 'recompose/compose';
import withServices from '../../Contexts/Services/WithServices.context';
import useTranslation from '../../Support/I18n/UseTranslation/I18nUseTranlation.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import SpeedDialActionWrapperPropTypes from './SpeedDialActionWrapper.component.props';
import speedDialActionWrapperStyles from './SpeedDialActionWrapper.component.styles';

/**
 * SpeedDialActionWrapperComponent
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const SpeedDialActionWrapperComponent = ({ classes, icon, tooltip, onClick, open, services }) => {
  const {
    i18n: { key, data, englishValue },
  } = tooltip;
  const translatedValue = useTranslation(services, key, data);
  return (
    <SpeedDialAction
      classes={{ staticTooltipLabel: classes.tooltip }}
      icon={<span className={classes.speedDialIcon}>{icon}</span>}
      interactive
      key={key}
      onClick={onClick}
      open={open}
      tooltipOpen
      tooltipTitle={englishValue || translatedValue}

    />
  );
};

SpeedDialActionWrapperComponent.propTypes = SpeedDialActionWrapperPropTypes;

const SpeedDialActionWrapper = compose(
  withServices,
  withStyles(themeCreateInjectableStyles(speedDialActionWrapperStyles), { withTheme: true }),
)(SpeedDialActionWrapperComponent);

export default SpeedDialActionWrapper;
